import format from "date-fns-tz/format";
import utcToZonedTime from "date-fns-tz/utcToZonedTime";

const dateTime = (value, formatToken = "dd MMM yyyy, hh:mm a") => {
  const userTimeZone = undefined;
  const date = userTimeZone ? utcToZonedTime(value, userTimeZone) : value;
  return format(date, formatToken, {
    timeZone: userTimeZone
  });
};

export default dateTime;
